exports.version = "1.9.2"


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client/version.js
// module id = 632
// module chunks = 40